import css from 'styled-jsx/css';

const styles = css`.maintenance{background:#fafafa;display:flex;align-items:center;justify-content:center;min-height:100vh;padding:20px}.maintenance h1{font-size:1.125rem;line-height:1.25rem;text-align:center}.maintenance .message{margin-top:20px}`;

export default styles;